export function HxChip({ tone = "gray", className = "", children, ...rest }) {
  return <span className={`hx-chip hx-chip--${tone} ${className}`} {...rest}>{children}</span>;
}

export function HxTile({ tone = "blue", size = 42, radius, className = "", children, ...rest }) {
  return (
    <span
      className={`hx-tile hx-tile--${tone} ${className}`}
      style={{ width: size, height: size, borderRadius: radius }}
      {...rest}
    >
      {children}
    </span>
  );
}
